<div class="modal-content spinner-container"> 
    <h3 class="titulo-aguarde">Aguarde</h3>
    <mat-spinner></mat-spinner> 
</div>